import { unstable_createChainedFunction as createChainedFunction } from '@material-ui/utils';
export default createChainedFunction;